<template>
  <a-form :form="form" layout="vertical">
    <a-row :gutter="16">
      <a-col :span="8">
        <a-form-item label="Soort">
          <a-select
              v-model="valuation.type"
              placeholder="Selecteer een soort"
          >
            <a-select-option v-for="(valuationTypeName, valuationType) in valuationTypes" :key="valuationType" :value="valuationType">
              {{ valuationTypeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="Waarde">
          <a-input
              type="number"
              v-model="valuation.value"
              placeholder="Marktwaarde"
          />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="Registratiedatum">
          <a-date-picker
              style="display:block;"
              v-model="registrationDate"
              v-on:change="onRegistrationDateChange"
              format="DD/MM/YYYY"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>
<script>
import moment from 'moment';
import propertyApi from '~/api/property';
import {DateFormatEnum} from "../../../enums";

export default {
  name: "PropertyValuationEditComponent",
  components: {},
  props: {
    valuation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      countries: [],
      form: this.$form.createForm(this),
      visible: false,
      registrationDate: moment(),
      valuationTypes: {
        market_value: 'Marktwaarde',
        real_estate_value: 'WOZ waarde',
      },
    };
  },
  mounted() {
    if (this.valuation.registration_date !== null) {
      this.registrationDate = moment(this.valuation.registration_date, DateFormatEnum.ISO8601);
    }
  },
  methods: {
    showDrawer() {
      this.visible = true;
    },
    onSubmit() {
      propertyApi.update(this.property).then(() => {
        this.visible = false;
      }).catch(error => {
        this.$message.error('Er ging iets mis tijdens het bijwerken van het pand');
      });
    },
    onRegistrationDateChange() {
      this.valuation.registration_date = this.registrationDate.format(DateFormatEnum.ISO8601);
    },
    onClose() {
      this.visible = false;
    },
  },
};
</script>
<style scoped>
.drawer-title {
  margin-bottom: 30px;
}
.pull-right {
  float: right;
}
</style>